import {
  FDHeadlineText, FDImage,
  FDStack, PrimaryActionButton,
} from '@facet-wealth/design';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import DrawerComponent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import classNames from 'classnames';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { dataAttrs, DataValueMap } from 'Helpers/Testing';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';
import { ExplorePage } from './ExplorePage';

const useStyles = buildUseStyles('Template', ((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paper: {
    width: 'unset',
    height: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.facet.lightGray,
  },
})));

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly);

export const ExploreItem = ({ resource }) => {
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  const handleClose = () => setOpen(false);

  if (!resource) {
    return null;
  }

  return (
    <>
      <BorderedTransparentBox padding={2} color={'info'} flex={1}>
        <FDStack
          alignItems={'center'}
          spacing={2}
          justifyContent={'center'}
          paddingY={4}
          paddingX={2}
          height={'100%'}
          direction={'column'}
          {...dataAttrs('explore-item')}
        >
          {resource.withRelationship(fr.relationships.image.name,
            (rel) => <FDImage alt={''} src={rel.link('related').url()} rounded={false} />,
            () => null)}
          <MetaControl attrName={'title'} metaOverrideSet={metaOverrides} resource={resource} />
          <PrimaryActionButton onClick={() => setOpen(true)} label={'View details'} {...dataAttrs('explore-item-details-button')} />
        </FDStack>
      </BorderedTransparentBox>
      <DrawerComponent
        anchor={'bottom'}
        onClose={() => setOpen(false)}
        variant={'temporary'}
        open={open}
        PaperProps={{
          className: classNames(classes.paper),
        }}
        transitionDuration={300}
      >
        <div
          className={classes.header}
        >
          <IconButton
            onClick={handleClose}
            color={'inherit'}
            icon={CloseIcon}
            title={'Close'}
            {...DataValueMap.init('drawer-close').build()}
          />
        </div>
        <MetaResourceRenderer
          resource={resource}
          layout={ExplorePage}
          // metaOverrideSet={metaOverrides}
        />
      </DrawerComponent>
    </>
  );
};

ExploreItem.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
